import {apiPost, API_URL} from '../api'

interface IProps {
    exchange: string
    exchange_maker_fee_rate: number
    exchange_taker_fee_rate: number
    max_reward_rate: number
    status: number
    referral_code: string
}

export const createReferral = async ({
    exchange,
    referral_code,
    exchange_taker_fee_rate,
    exchange_maker_fee_rate,
    max_reward_rate,
    status,
}: IProps) => {
    return await apiPost(API_URL, 'admin/exchange/referral', {
        exchange: exchange,
        referral_code,
        exchange_taker_fee_rate,
        exchange_maker_fee_rate,
        max_reward_rate,
        status,
    })
}
